import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { useCronContext } from "../../../context/CronContext";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import CronEditor from "./CronEditor";

const CronMainSection = ({ file }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const { cronData, setCronData } = useCronContext();

  const fetchCron = async (id) => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(`/cronconfig/${id}`);
      setCronData(data);
    } catch (error) {
      setError(error);
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (file.id) {
      fetchCron(file.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!cronData) return null;

  return <CronEditor file={file} cronData={cronData} setCronData={setCronData} />;
};

export default CronMainSection;
